import RuleActionModel from '@/common/models/rules/actions/rule-action-model';

export default class RequestKYCActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        const {
            excludePolicy = RequestKYCActionModel
                .ExcludePolicies.customersWithAcceptedDocument,
            isMandatory = true,
            promptPolicy = RequestKYCActionModel
                .PromptPolicies.beforeTransactionProcess,
            rejectedBeforeTransactionProcessPolicy = RequestKYCActionModel
                .RejectedBeforeTransactionProcessPolicies.decline,
            alternateGatewayAccountIfRejected = null,
            rejectedAfterTransactionProcessPolicy = RequestKYCActionModel
                .RejectedAfterTransactionProcessPolicies.proceed,
            optionalPolicy = RequestKYCActionModel.OptionalPolicies.allowBypass,
            alternateGatewayAccountIfOptional = null,
            bypassCurrencyToDisplay = null,
        } = fields;
        this.excludePolicy = excludePolicy;
        this.isMandatory = isMandatory;
        this.promptPolicy = promptPolicy;
        this.rejectedBeforeTransactionProcessPolicy = rejectedBeforeTransactionProcessPolicy;
        this.alternateGatewayAccountIfRejected = alternateGatewayAccountIfRejected;
        this.rejectedAfterTransactionProcessPolicy = rejectedAfterTransactionProcessPolicy;
        this.optionalPolicy = optionalPolicy;
        this.alternateGatewayAccountIfOptional = alternateGatewayAccountIfOptional;
        this.bypassCurrencyToDisplay = bypassCurrencyToDisplay;
    }

    static ExcludePolicies = {
        customersWithAcceptedDocument: 'customers-with-accepted-document',
        customersWithDocument: 'customers-with-document',
        none: 'none',
    };

    static PromptPolicies = {
        afterTransactionProcess: 'after-transaction-process',
        beforeTransactionProcess: 'before-transaction-process',
    };

    static RejectedBeforeTransactionProcessPolicies = {
        decline: 'decline',
        processTransaction: 'process-transaction',
        useAlternateGateway: 'use-alternate-gateway',
    };

    static RejectedAfterTransactionProcessPolicies = {proceed: 'proceed'};

    static OptionalPolicies = {
        allowBypass: 'allow-bypass',
        allowUseAlternateGateway: 'allow-use-alternate-gateway',
    };

    getPayload() {
        return {
            ...super.getPayload(),
            excludePolicy: this.excludePolicy,
            isMandatory: this.isMandatory,
            promptPolicy: this.promptPolicy,
            rejectedBeforeTransactionProcessPolicy: this.rejectedBeforeTransactionProcessPolicy,
            alternateGatewayAccountIfRejected: this.alternateGatewayAccountIfRejected,
            rejectedAfterTransactionProcessPolicy: this.rejectedAfterTransactionProcessPolicy,
            optionalPolicy: this.optionalPolicy,
            alternateGatewayAccountIfOptional: this.alternateGatewayAccountIfOptional,
            bypassCurrencyToDisplay: this.bypassCurrencyToDisplay,
        };
    }
}
